import { IUser } from 'core/interface/user';
import ApiBase from '../base/apiBase';
import { setRequestError } from '../../redux/slices/errors';
import { store } from '../../redux/store';
import { SaveFiles } from '../../redux/slices/file';
import { TFunction } from 'i18next';
import { CandidateService } from '../candidate/candidate';
import { CvUploadResult } from 'core/interface/cv-skills-review';
import {
  normalizeSkillList,
  skillsNotIn,
  uniqSkills
} from 'utils/normalizeSkillList';

export class AccountServce {
  private static apiBase = new ApiBase();

  public static async uploadCV(
    candidate_id: number,
    body: FormData,
    t: TFunction
  ): Promise<CvUploadResult> {
    const { dispatch } = store;
    const emptyResult: CvUploadResult = {
      success: false,
      hasExtractedSkills: false,
      existingHardSkills: [],
      existingSoftSkills: [],
      extractedHardSkills: [],
      extractedSoftSkills: [],
      previewHardSkills: [],
      previewSoftSkills: []
    };

    try {
      const existingCandidate =
        await CandidateService.getCandidate(candidate_id);

      const res = await this.apiBase.updateAsync(
        `/candidates/${candidate_id}/`,
        body
      );
      CandidateService.saveCandidateFromPatch(res);

      const existingHardSkills = normalizeSkillList(
        existingCandidate?.hard_skills
      );
      const existingSoftSkills = normalizeSkillList(
        existingCandidate?.soft_skills
      );
      const responseHardSkills = normalizeSkillList(res?.hard_skills);
      const responseSoftSkills = normalizeSkillList(res?.soft_skills);

      const extractedHardSkills = uniqSkills(
        skillsNotIn(existingHardSkills, responseHardSkills)
      );
      const extractedSoftSkills = uniqSkills(
        skillsNotIn(existingSoftSkills, responseSoftSkills)
      );

      const hasExtractedSkills =
        extractedHardSkills.length > 0 || extractedSoftSkills.length > 0;

      await CandidateService.getCandidate(candidate_id);

      if (!hasExtractedSkills) {
        dispatch(setRequestError(t('CV Uploaded'), true));
      }

      return {
        success: true,
        hasExtractedSkills,
        existingHardSkills,
        existingSoftSkills,
        extractedHardSkills,
        extractedSoftSkills,
        previewHardSkills: uniqSkills([
          ...existingHardSkills,
          ...responseHardSkills
        ]),
        previewSoftSkills: uniqSkills([
          ...existingSoftSkills,
          ...responseSoftSkills
        ])
      };
    } catch (error) {
      dispatch(setRequestError({ data: `${t('Request Entity Too Large')}` }));
      return emptyResult;
    }
  }

  public static async updateAccount(
    candidate_id: number,
    data: FormData
  ): Promise<IUser> {
    return await this.apiBase.updateAsync(`/account/${candidate_id}/`, data);
  }
  public static async getUploadedImages(candidate_id: number): Promise<any> {
    const { dispatch } = store;
    try {
      const res = await this.apiBase.getAsync(
        `/candidates/${candidate_id}/files/`
      );
      dispatch(SaveFiles(res));
    } catch (error) {
      console.log(error);
    }
  }
  public static async uploadImages(
    candidate_id: number,
    body: any
  ): Promise<any> {
    try {
      await this.apiBase.postAsync(`/candidates/${candidate_id}/files/`, body);
      AccountServce.getUploadedImages(candidate_id);
    } catch (error) {
      console.log(error);
    }
  }
  public static async removeUploadedImages(
    candidate_id: number,
    file_id: number
  ): Promise<any> {
    try {
      const res = await this.apiBase.deleteAsync(
        `/candidates/${candidate_id}/files/${file_id}/`
      );
      console.log(res);

      AccountServce.getUploadedImages(candidate_id);
    } catch (error) {
      console.log(error);
    }
  }

  public static async uploadCompanyLogo(
    company_id: string,
    logoFile: File
  ): Promise<any> {
    try {
      const logoFormData = new FormData();
      logoFormData.append('logo', logoFile);
      
      const res = await this.apiBase.updateAsync(
        `/companies/${company_id}/`,
        logoFormData
      );
      return res;
    } catch (error) {
      console.log('Error uploading company logo:', error);
      throw error;
    }
  }
}
